import React from 'react';
import { CTAButton } from '../components/CTAButton';
import { FAQItem } from '../components/FAQItem';
import { CheckIcon } from 'lucide-react';
export function SalesPage() {
  const handleCTAClick = () => {
    // In production, this would link to payment/checkout
    console.log('CTA clicked - redirect to purchase');
  };
  return <main className="min-h-screen w-full bg-cream-100" data-id="element-9">
      {/* Hero Section */}
      <section className="relative py-16 md:py-24 px-4 overflow-hidden" data-id="element-10">
        <div className="max-w-4xl mx-auto" data-id="element-11">
          <div className="text-center mb-12" data-id="element-12">
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-13">
              Lanza Tu Negocio Digital en 14 Días
            </h1>
            <p className="font-heading text-2xl md:text-3xl text-teal-600 mb-8" data-id="element-14">
              (Sin Ser Influencer, Sin Seguidores, Sin Exponerte)
            </p>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto mb-12 leading-relaxed" data-id="element-15">
              Kit práctico para mujeres 50+ que quieren un ingreso propio desde
              casa, con autenticidad y sin complicaciones técnicas
            </p>
          </div>

          <div className="mb-12 rounded-2xl overflow-hidden shadow-2xl max-w-2xl mx-auto" data-id="element-16">
            <img src="https://cdn.magicpatterns.com/uploads/nAeAS6XHkLCmxczUvrmDt6/heylloyd-image-1771128118958.png" alt="Mujer trabajando en su laptop desde casa, emprendiendo su negocio digital" className="w-full h-auto" data-id="element-17" />
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-8" data-id="element-18">
            <h2 className="font-heading text-2xl font-semibold text-gray-900 mb-6" data-id="element-19">
              En 14 días tendrás:
            </h2>
            <ul className="space-y-4 mb-10" role="list" data-id="element-20">
              <li className="flex items-start" data-id="element-21">
                <CheckIcon className="w-6 h-6 text-teal-500 mr-4 mt-1 flex-shrink-0" aria-hidden="true" data-id="element-22" />
                <span className="text-gray-700 text-lg" data-id="element-23">
                  Crea tu primer producto digital vendible en menos de una
                  semana
                </span>
              </li>
              <li className="flex items-start" data-id="element-24">
                <CheckIcon className="w-6 h-6 text-teal-500 mr-4 mt-1 flex-shrink-0" aria-hidden="true" data-id="element-25" />
                <span className="text-gray-700 text-lg" data-id="element-26">
                  Valida tu idea sin necesidad de miles de seguidores
                </span>
              </li>
              <li className="flex items-start" data-id="element-27">
                <CheckIcon className="w-6 h-6 text-teal-500 mr-4 mt-1 flex-shrink-0" aria-hidden="true" data-id="element-28" />
                <span className="text-gray-700 text-lg" data-id="element-29">
                  Genera tus primeras ventas por WhatsApp o mensajes directos
                </span>
              </li>
              <li className="flex items-start" data-id="element-30">
                <CheckIcon className="w-6 h-6 text-teal-500 mr-4 mt-1 flex-shrink-0" aria-hidden="true" data-id="element-31" />
                <span className="text-gray-700 text-lg" data-id="element-32">
                  Invierte solo 30-60 minutos al día
                </span>
              </li>
              <li className="flex items-start" data-id="element-33">
                <CheckIcon className="w-6 h-6 text-teal-500 mr-4 mt-1 flex-shrink-0" aria-hidden="true" data-id="element-34" />
                <span className="text-gray-700 text-lg" data-id="element-35">
                  Sin web compleja, sin embudos, sin ser influencer
                </span>
              </li>
            </ul>

            <div className="text-center" data-id="element-36">
              <div className="mb-6" data-id="element-37">
                <div className="mb-2" data-id="element-38">
                  <span className="text-2xl font-semibold text-gray-400 line-through" data-id="element-39">
                    $19.99
                  </span>
                  <span className="ml-3 inline-block bg-terracotta-500 text-white px-3 py-1 rounded-full text-sm font-bold" data-id="element-40">
                    68% OFF
                  </span>
                </div>
                <div className="text-4xl font-bold text-terracotta-500 mb-1" data-id="element-41">
                  $6.39
                </div>
                <p className="text-terracotta-600 font-semibold text-sm" data-id="element-42">
                  Oferta especial disponible ahora
                </p>
              </div>

              <CTAButton onClick={handleCTAClick} className="w-full md:w-auto" data-id="element-43">
                Comprar ahora por $6.39
              </CTAButton>
              <p className="text-gray-600 mt-4 text-sm" data-id="element-44">
                Descarga inmediata en PDF
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Identificación Emocional */}
      <section className="py-16 md:py-24 px-4 bg-white" data-id="element-45">
        <div className="max-w-4xl mx-auto" data-id="element-46">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center" data-id="element-47">
            Si alguna vez has pensado...
          </h2>

          <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-48">
            <div className="bg-cream-100 p-6 rounded-xl border-l-4 border-terracotta-500" data-id="element-49">
              <p className="text-gray-800 text-lg font-medium" data-id="element-50">
                "Llegué tarde. Ya todos están haciendo esto."
              </p>
            </div>
            <div className="bg-cream-100 p-6 rounded-xl border-l-4 border-terracotta-500" data-id="element-51">
              <p className="text-gray-800 text-lg font-medium" data-id="element-52">
                "La tecnología me agobia. No sé ni por dónde empezar."
              </p>
            </div>
            <div className="bg-cream-100 p-6 rounded-xl border-l-4 border-terracotta-500" data-id="element-53">
              <p className="text-gray-800 text-lg font-medium" data-id="element-54">
                "No sé qué vender. No soy experta en nada especial."
              </p>
            </div>
            <div className="bg-cream-100 p-6 rounded-xl border-l-4 border-terracotta-500" data-id="element-55">
              <p className="text-gray-800 text-lg font-medium" data-id="element-56">
                "Me da pena. ¿Qué dirán mi familia y amigos si me ven
                vendiendo?"
              </p>
            </div>
          </div>

          <div className="bg-teal-500 text-white p-8 rounded-2xl text-center" data-id="element-57">
            <p className="text-xl md:text-2xl leading-relaxed" data-id="element-58">
              No estás sola. Y no llegaste tarde. Lo que necesitas no es ser
              influencer. Es un método claro y un primer paso concreto.
            </p>
          </div>
        </div>
      </section>

      {/* Reencuadre: El Mito del Influencer */}
      <section className="py-16 md:py-24 px-4 bg-cream-100" data-id="element-59">
        <div className="max-w-4xl mx-auto" data-id="element-60">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center" data-id="element-61">
            No Necesitas Ser Influencer Para Vender Online
          </h2>

          <div className="space-y-6" data-id="element-62">
            <div className="bg-white p-8 rounded-xl shadow-md" data-id="element-63">
              <h3 className="font-heading text-xl font-semibold text-terracotta-500 mb-3" data-id="element-64">
                El mito:
              </h3>
              <p className="text-gray-700 text-lg leading-relaxed" data-id="element-65">
                Necesitas miles de seguidores, aparecer en video, ser
                carismática en redes.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-md" data-id="element-66">
              <h3 className="font-heading text-xl font-semibold text-teal-600 mb-3" data-id="element-67">
                La realidad:
              </h3>
              <p className="text-gray-700 text-lg leading-relaxed" data-id="element-68">
                Lo que necesitas es una promesa clara, un mecanismo simple, y un
                canal directo (como WhatsApp).
              </p>
            </div>

            <div className="bg-teal-600 text-white p-8 rounded-xl" data-id="element-69">
              <p className="text-lg leading-relaxed" data-id="element-70">
                Las ventas no vienen de la exposición masiva. Vienen de
                conversaciones reales con personas que tienen un problema que tú
                puedes resolver.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Qué Vas a Lograr en 14 Días */}
      <section className="py-16 md:py-24 px-4 bg-white" data-id="element-71">
        <div className="max-w-4xl mx-auto" data-id="element-72">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center" data-id="element-73">
            En 14 Días Tendrás Esto Listo
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-74">
            <div className="bg-cream-100 p-8 rounded-xl" data-id="element-75">
              <div className="w-12 h-12 bg-terracotta-500 rounded-full flex items-center justify-center mb-4" data-id="element-76">
                <span className="text-white font-bold text-xl" data-id="element-77">1</span>
              </div>
              <h3 className="font-heading text-xl font-semibold text-gray-900 mb-3" data-id="element-78">
                Tu primera oferta clara
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-79">
                Qué vendes, a quién, por qué te comprarían
              </p>
            </div>

            <div className="bg-cream-100 p-8 rounded-xl" data-id="element-80">
              <div className="w-12 h-12 bg-terracotta-500 rounded-full flex items-center justify-center mb-4" data-id="element-81">
                <span className="text-white font-bold text-xl" data-id="element-82">2</span>
              </div>
              <h3 className="font-heading text-xl font-semibold text-gray-900 mb-3" data-id="element-83">
                Tu primer PDF vendible
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-84">
                Con contenido útil y estructura profesional
              </p>
            </div>

            <div className="bg-cream-100 p-8 rounded-xl" data-id="element-85">
              <div className="w-12 h-12 bg-terracotta-500 rounded-full flex items-center justify-center mb-4" data-id="element-86">
                <span className="text-white font-bold text-xl" data-id="element-87">3</span>
              </div>
              <h3 className="font-heading text-xl font-semibold text-gray-900 mb-3" data-id="element-88">
                9 mensajes auténticos listos
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-89">
                Que conectan sin sonar vendedora
              </p>
            </div>

            <div className="bg-cream-100 p-8 rounded-xl" data-id="element-90">
              <div className="w-12 h-12 bg-terracotta-500 rounded-full flex items-center justify-center mb-4" data-id="element-91">
                <span className="text-white font-bold text-xl" data-id="element-92">4</span>
              </div>
              <h3 className="font-heading text-xl font-semibold text-gray-900 mb-3" data-id="element-93">
                Sistema de validación rápida
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-94">
                Para saber si tu idea funciona antes de invertir más tiempo
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Qué Incluye el PDF */}
      <section className="py-16 md:py-24 px-4 bg-cream-100" data-id="element-95">
        <div className="max-w-4xl mx-auto" data-id="element-96">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center" data-id="element-97">
            Qué Viene en el Kit
          </h2>

          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12" data-id="element-98">
            <ul className="space-y-6" role="list" data-id="element-99">
              <li className="flex items-start" data-id="element-100">
                <CheckIcon className="w-6 h-6 text-teal-500 mr-4 mt-1 flex-shrink-0" aria-hidden="true" data-id="element-101" />
                <div data-id="element-102">
                  <h3 className="font-semibold text-gray-900 text-lg mb-1" data-id="element-103">
                    Guía paso a paso para crear tu primer PDF vendible
                  </h3>
                  <p className="text-gray-600" data-id="element-104">
                    En poco tiempo, sin complicaciones técnicas
                  </p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-105">
                <CheckIcon className="w-6 h-6 text-teal-500 mr-4 mt-1 flex-shrink-0" aria-hidden="true" data-id="element-106" />
                <div data-id="element-107">
                  <h3 className="font-semibold text-gray-900 text-lg mb-1" data-id="element-108">
                    Guiones de mensajes (dolor/deseo/prueba)
                  </h3>
                  <p className="text-gray-600" data-id="element-109">
                    Adaptados a tu experiencia, listos para usar
                  </p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-110">
                <CheckIcon className="w-6 h-6 text-teal-500 mr-4 mt-1 flex-shrink-0" aria-hidden="true" data-id="element-111" />
                <div data-id="element-112">
                  <h3 className="font-semibold text-gray-900 text-lg mb-1" data-id="element-113">
                    Método de validación
                  </h3>
                  <p className="text-gray-600" data-id="element-114">
                    Cómo probar tu idea sin exposición masiva
                  </p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-115">
                <CheckIcon className="w-6 h-6 text-teal-500 mr-4 mt-1 flex-shrink-0" aria-hidden="true" data-id="element-116" />
                <div data-id="element-117">
                  <h3 className="font-semibold text-gray-900 text-lg mb-1" data-id="element-118">
                    Manejo de objeciones y miedos
                  </h3>
                  <p className="text-gray-600" data-id="element-119">
                    Qué decir cuando te da pena o inseguridad
                  </p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-120">
                <CheckIcon className="w-6 h-6 text-teal-500 mr-4 mt-1 flex-shrink-0" aria-hidden="true" data-id="element-121" />
                <div data-id="element-122">
                  <h3 className="font-semibold text-gray-900 text-lg mb-1" data-id="element-123">
                    Plan de acción detallado de 14 días
                  </h3>
                  <p className="text-gray-600" data-id="element-124">
                    Qué hacer cada día en 30-60 minutos
                  </p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-125">
                <CheckIcon className="w-6 h-6 text-teal-500 mr-4 mt-1 flex-shrink-0" aria-hidden="true" data-id="element-126" />
                <div data-id="element-127">
                  <h3 className="font-semibold text-gray-900 text-lg mb-1" data-id="element-128">
                    Checklists y plantillas
                  </h3>
                  <p className="text-gray-600" data-id="element-129">
                    Listas para usar, sin empezar desde cero
                  </p>
                </div>
              </li>
            </ul>

            <div className="mt-10 p-6 bg-teal-50 rounded-xl border-l-4 border-teal-500" data-id="element-130">
              <p className="text-gray-800 text-lg font-medium" data-id="element-131">
                Todo es acción. Nada de teoría que no puedas aplicar hoy.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Cómo Funciona el Método 3/3/3 */}
      <section className="py-16 md:py-24 px-4 bg-white" data-id="element-132">
        <div className="max-w-4xl mx-auto" data-id="element-133">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-gray-900 mb-4 text-center" data-id="element-134">
            El Método 3/3/3: Simple y Efectivo
          </h2>
          <p className="text-xl text-gray-600 text-center mb-12 max-w-2xl mx-auto" data-id="element-135">
            Tres componentes claros que funcionan juntos
          </p>

          <div className="space-y-8" data-id="element-136">
            <div className="bg-cream-100 rounded-2xl p-8 md:p-10" data-id="element-137">
              <div className="flex items-center mb-6" data-id="element-138">
                <div className="w-16 h-16 bg-terracotta-500 rounded-full flex items-center justify-center mr-4" data-id="element-139">
                  <span className="text-white font-bold text-2xl" data-id="element-140">3</span>
                </div>
                <h3 className="font-heading text-2xl font-bold text-gray-900" data-id="element-141">
                  Activos Digitales
                </h3>
              </div>
              <div className="space-y-4" data-id="element-142">
                <p className="text-gray-700 text-lg leading-relaxed" data-id="element-143">
                  <strong data-id="element-144">Qué vender:</strong> Guía práctica, checklist,
                  mini-curso en PDF
                </p>
                <p className="text-gray-700 text-lg leading-relaxed" data-id="element-145">
                  <strong data-id="element-146">Cómo empaquetar:</strong> Tu experiencia en algo útil
                  y vendible
                </p>
              </div>
            </div>

            <div className="bg-cream-100 rounded-2xl p-8 md:p-10" data-id="element-147">
              <div className="flex items-center mb-6" data-id="element-148">
                <div className="w-16 h-16 bg-teal-500 rounded-full flex items-center justify-center mr-4" data-id="element-149">
                  <span className="text-white font-bold text-2xl" data-id="element-150">3</span>
                </div>
                <h3 className="font-heading text-2xl font-bold text-gray-900" data-id="element-151">
                  Mensajes Auténticos
                </h3>
              </div>
              <div className="space-y-4" data-id="element-152">
                <p className="text-gray-700 text-lg leading-relaxed" data-id="element-153">
                  <strong data-id="element-154">Qué decir:</strong> Para conectar sin sonar falsa
                </p>
                <p className="text-gray-700 text-lg leading-relaxed" data-id="element-155">
                  <strong data-id="element-156">Cómo hablar:</strong> De tu oferta con naturalidad
                </p>
              </div>
            </div>

            <div className="bg-cream-100 rounded-2xl p-8 md:p-10" data-id="element-157">
              <div className="flex items-center mb-6" data-id="element-158">
                <div className="w-16 h-16 bg-terracotta-600 rounded-full flex items-center justify-center mr-4" data-id="element-159">
                  <span className="text-white font-bold text-2xl" data-id="element-160">3</span>
                </div>
                <h3 className="font-heading text-2xl font-bold text-gray-900" data-id="element-161">
                  Pruebas de Validación Rápida
                </h3>
              </div>
              <div className="space-y-4" data-id="element-162">
                <p className="text-gray-700 text-lg leading-relaxed" data-id="element-163">
                  <strong data-id="element-164">Cómo validar:</strong> Tu idea en días (no meses)
                </p>
                <p className="text-gray-700 text-lg leading-relaxed" data-id="element-165">
                  <strong data-id="element-166">Cómo ajustar:</strong> Sin necesidad de seguidores
                  masivos
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Plan de 14 Días */}
      <section className="py-16 md:py-24 px-4 bg-cream-100" data-id="element-167">
        <div className="max-w-4xl mx-auto" data-id="element-168">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-gray-900 mb-4 text-center" data-id="element-169">
            Tu Plan de 14 Días
          </h2>
          <p className="text-xl text-gray-600 text-center mb-12" data-id="element-170">
            30-60 minutos al día
          </p>

          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12" data-id="element-171">
            <div className="space-y-6" data-id="element-172">
              <div className="border-l-4 border-terracotta-500 pl-6 py-2" data-id="element-173">
                <h3 className="font-heading text-xl font-semibold text-gray-900 mb-2" data-id="element-174">
                  Días 1-3: Define tu oferta y avatar
                </h3>
                <p className="text-gray-600" data-id="element-175">
                  Identifica qué problema resuelves y para quién
                </p>
              </div>

              <div className="border-l-4 border-teal-500 pl-6 py-2" data-id="element-176">
                <h3 className="font-heading text-xl font-semibold text-gray-900 mb-2" data-id="element-177">
                  Días 4-7: Crea tu primer PDF vendible
                </h3>
                <p className="text-gray-600" data-id="element-178">
                  Estructura y contenido paso a paso
                </p>
              </div>

              <div className="border-l-4 border-terracotta-500 pl-6 py-2" data-id="element-179">
                <h3 className="font-heading text-xl font-semibold text-gray-900 mb-2" data-id="element-180">
                  Días 8-10: Escribe tus mensajes de venta
                </h3>
                <p className="text-gray-600" data-id="element-181">Guiones auténticos que conectan</p>
              </div>

              <div className="border-l-4 border-teal-500 pl-6 py-2" data-id="element-182">
                <h3 className="font-heading text-xl font-semibold text-gray-900 mb-2" data-id="element-183">
                  Días 11-12: Valida con conversaciones reales
                </h3>
                <p className="text-gray-600" data-id="element-184">
                  Prueba tu oferta sin exposición masiva
                </p>
              </div>

              <div className="border-l-4 border-terracotta-500 pl-6 py-2" data-id="element-185">
                <h3 className="font-heading text-xl font-semibold text-gray-900 mb-2" data-id="element-186">
                  Días 13-14: Ajusta y lanza
                </h3>
                <p className="text-gray-600" data-id="element-187">
                  Mejora según feedback y empieza a vender
                </p>
              </div>
            </div>

            <div className="mt-10 p-6 bg-teal-50 rounded-xl border-l-4 border-teal-500" data-id="element-188">
              <p className="text-gray-800 text-lg font-medium" data-id="element-189">
                No necesitas hacerlo perfecto. Solo necesitas empezar.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Para Quién Es / Para Quién NO Es */}
      <section className="py-16 md:py-24 px-4 bg-white" data-id="element-190">
        <div className="max-w-4xl mx-auto" data-id="element-191">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center" data-id="element-192">
            ¿Es Para Ti?
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-193">
            <div className="bg-teal-50 rounded-2xl p-8 border-2 border-teal-500" data-id="element-194">
              <h3 className="font-heading text-2xl font-bold text-teal-700 mb-6" data-id="element-195">
                Para quién SÍ es:
              </h3>
              <ul className="space-y-4" role="list" data-id="element-196">
                <li className="flex items-start" data-id="element-197">
                  <CheckIcon className="w-6 h-6 text-teal-600 mr-3 mt-1 flex-shrink-0" aria-hidden="true" data-id="element-198" />
                  <span className="text-gray-800" data-id="element-199">
                    Mujeres 50+ que quieren un ingreso propio desde casa
                  </span>
                </li>
                <li className="flex items-start" data-id="element-200">
                  <CheckIcon className="w-6 h-6 text-teal-600 mr-3 mt-1 flex-shrink-0" aria-hidden="true" data-id="element-201" />
                  <span className="text-gray-800" data-id="element-202">
                    Quieres algo tuyo, con tu nombre, con tu experiencia
                  </span>
                </li>
                <li className="flex items-start" data-id="element-203">
                  <CheckIcon className="w-6 h-6 text-teal-600 mr-3 mt-1 flex-shrink-0" aria-hidden="true" data-id="element-204" />
                  <span className="text-gray-800" data-id="element-205">
                    Estás dispuesta a invertir 30-60 min al día durante 14 días
                  </span>
                </li>
                <li className="flex items-start" data-id="element-206">
                  <CheckIcon className="w-6 h-6 text-teal-600 mr-3 mt-1 flex-shrink-0" aria-hidden="true" data-id="element-207" />
                  <span className="text-gray-800" data-id="element-208">
                    Prefieres conversaciones directas (WhatsApp/DM) que
                    exposición masiva
                  </span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-100 rounded-2xl p-8 border-2 border-gray-300" data-id="element-209">
              <h3 className="font-heading text-2xl font-bold text-gray-700 mb-6" data-id="element-210">
                Para quién NO es:
              </h3>
              <ul className="space-y-4" role="list" data-id="element-211">
                <li className="flex items-start" data-id="element-212">
                  <span className="text-gray-500 mr-3 mt-1 text-xl" data-id="element-213">×</span>
                  <span className="text-gray-700" data-id="element-214">
                    Buscas hacerte rica rápido sin esfuerzo
                  </span>
                </li>
                <li className="flex items-start" data-id="element-215">
                  <span className="text-gray-500 mr-3 mt-1 text-xl" data-id="element-216">×</span>
                  <span className="text-gray-700" data-id="element-217">
                    No estás dispuesta a salir de tu zona de confort (aunque sea
                    un poquito)
                  </span>
                </li>
                <li className="flex items-start" data-id="element-218">
                  <span className="text-gray-500 mr-3 mt-1 text-xl" data-id="element-219">×</span>
                  <span className="text-gray-700" data-id="element-220">
                    Quieres que alguien más haga el trabajo por ti
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ + Objeciones */}
      <section className="py-16 md:py-24 px-4 bg-cream-100" data-id="element-221">
        <div className="max-w-4xl mx-auto" data-id="element-222">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-gray-900 mb-4 text-center" data-id="element-223">
            Preguntas Frecuentes
          </h2>
          <p className="text-xl text-gray-600 text-center mb-12" data-id="element-224">
            Respuestas claras a tus dudas
          </p>

          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12" data-id="element-225">
            <div className="space-y-2" data-id="element-226">
              <FAQItem question="No soy experta en nada. ¿Qué puedo vender?" answer="No necesitas ser experta. Necesitas saber algo que alguien más quiere aprender. Si has resuelto un problema (criar hijos, organizarte, cuidar tu salud, manejar tu dinero), tienes experiencia vendible." data-id="element-227" />
              <FAQItem question="No tengo tiempo. Trabajo/cuido a alguien/tengo mil cosas." answer="El plan está diseñado para 30-60 min al día. No necesitas horas libres. Necesitas constancia en pequeños pasos." data-id="element-228" />
              <FAQItem question="¿Y si nadie compra?" answer="El método incluye validación rápida. Vas a probar tu idea antes de invertir mucho tiempo. Si no funciona, ajustas. No pierdes meses." data-id="element-229" />
              <FAQItem question="¿Necesito tener seguidores en redes sociales?" answer="No. El método está diseñado para vender por conversaciones directas (WhatsApp, DM). No necesitas audiencia masiva." data-id="element-230" />
              <FAQItem question="¿Tengo que mostrar mi cara o hacer videos?" answer="No. Puedes vender con mensajes escritos. Sin cámara, sin exposición." data-id="element-231" />
              <FAQItem question="¿Necesito una página web o algo técnico?" answer="No. El método es deliberadamente simple: PDF + mensajes + WhatsApp/DM. Nada de embudos complejos." data-id="element-232" />
              <FAQItem question="Soy cero tecnológica. ¿Podré hacerlo?" answer="Si sabes usar WhatsApp y enviar un PDF, tienes todo lo que necesitas. El kit evita tecnicismos." data-id="element-233" />
              <FAQItem question="¿Hay garantía de devolución?" answer="No ofrecemos garantía. Es un producto digital de bajo costo ($6.39). Lo que sí garantizamos: contenido claro, accionable, sin relleno." data-id="element-234" />
            </div>
          </div>
        </div>
      </section>

      {/* Compra Consciente */}
      <section className="py-16 md:py-24 px-4 bg-white" data-id="element-235">
        <div className="max-w-4xl mx-auto" data-id="element-236">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center" data-id="element-237">
            Compra Consciente
          </h2>

          <div className="bg-cream-100 rounded-2xl p-8 md:p-12 border-2 border-gray-300" data-id="element-238">
            <div className="space-y-6" data-id="element-239">
              <p className="text-gray-800 text-lg leading-relaxed" data-id="element-240">
                <strong data-id="element-241">Este es un producto educativo.</strong> Los resultados
                dependen de tu ejecución.
              </p>
              <p className="text-gray-800 text-lg leading-relaxed" data-id="element-242">
                <strong data-id="element-243">No es una fórmula mágica.</strong> Es un método probado
                que requiere acción de tu parte.
              </p>
              <p className="text-gray-800 text-lg leading-relaxed" data-id="element-244">
                <strong data-id="element-245">Si buscas garantías de éxito sin esfuerzo,</strong> este
                no es para ti.
              </p>
              <p className="text-gray-800 text-lg leading-relaxed font-semibold" data-id="element-246">
                Si buscas un plan claro, pasos concretos, y estás dispuesta a
                intentarlo, esto es exactamente lo que necesitas.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Precio y CTA Final */}
      <section className="py-16 md:py-24 px-4 bg-gradient-to-b from-cream-100 to-teal-50" data-id="element-247">
        <div className="max-w-4xl mx-auto" data-id="element-248">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center" data-id="element-249">
            Invierte $6.39 Hoy. Empieza Mañana.
          </h2>

          <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12 mb-8" data-id="element-250">
            <div className="text-center mb-8" data-id="element-251">
              <p className="text-gray-700 text-lg mb-4" data-id="element-252">
                Un café cuesta más. Una consultoría cuesta cientos de dólares.
              </p>
              <p className="text-gray-900 text-xl font-semibold mb-6" data-id="element-253">
                Por menos de $7, tienes un plan completo de 14 días, plantillas,
                guiones, y un método validado.
              </p>

              <div className="inline-block mb-8" data-id="element-254">
                <div className="mb-3" data-id="element-255">
                  <span className="text-3xl font-semibold text-gray-400 line-through" data-id="element-256">
                    $19.99
                  </span>
                  <span className="ml-3 inline-block bg-terracotta-500 text-white px-3 py-1 rounded-full text-sm font-bold" data-id="element-257">
                    68% OFF
                  </span>
                </div>

                <div className="text-6xl font-bold text-terracotta-500 mb-2" data-id="element-258">
                  $6.39
                </div>
                <div className="text-gray-600 text-lg" data-id="element-259">USD - Pago único</div>
                <p className="text-terracotta-600 font-semibold mt-2 text-lg" data-id="element-260">
                  Oferta especial disponible ahora
                </p>
              </div>
            </div>

            <div className="text-center" data-id="element-261">
              <CTAButton onClick={handleCTAClick} className="w-full md:w-auto text-xl px-12 py-5" data-id="element-262">
                Sí, lo quiero por $6.39
              </CTAButton>
              <p className="text-gray-600 mt-6 text-lg font-medium" data-id="element-263">
                Descarga inmediata en PDF. Empieza hoy mismo.
              </p>
            </div>
          </div>

          <div className="text-center text-gray-600 text-sm" data-id="element-264">
            <p data-id="element-265">
              Material educativo. Resultados dependen de la ejecución
              individual.
            </p>
          </div>
        </div>
      </section>
    </main>;
}